import gql from "graphql-tag";

export function GET_THEME_EXTENSION_STATUS(themeId = null) {
  const path = themeId
    ? `/theme-extension-status?themeId=${themeId}`
    : "/theme-extension-status";
  return gql`
    query GetThemeExtensionStatus {
      themeExtensionStatus @rest(type: "ThemeExtensionStatus", path: "${path}", method: "GET") {
        Themes {
          Id
          Name
          Role
        }
        SelectedThemeId
        HeroBannerEnabled
        AppEmbedEnabled
        IsOnlineStore2
        AppBlocks {
          Handle
          Name
          Enabled
        }
      }
    }
  `;
}
